import { NgModule, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild, OnDestroy } from '@angular/core';
import { EditorController } from '../../controller/editor.controller';
import { SafeUrlPipe } from './safe-url.pipe';

@Component({
  selector: 'ide-panel-frame',
  template: `
      <iframe #iframe [attr.src]="src|safeUrl" frameborder="0" (load)="handleLoadEvent()"
        alt="Oppppppps! Cannot find the correct resource!" allowtransparency="true"></iframe>
    `,
  styles: [`
    :host {
      height: 100%;
      width: 100%;
    }
    iframe {
      height: 100%;
      width: 100%;
      border: none;
    }
  `]
})
export class PanelFrameComponent implements OnInit, OnDestroy {

  @Input() src: string;

  @ViewChild('iframe', { read: ElementRef }) iframe: ElementRef<HTMLIFrameElement>;

  @Output() iframeClick = new EventEmitter();

  /** iframe加载完毕后回调 */
  @Input() handleLoad: (iframe: HTMLIFrameElement) => void;

  constructor(
    private el: ElementRef<HTMLElement>,
    private controller: EditorController
  ) { }

  ngOnInit() {
    const iframeEl: HTMLIFrameElement = this.iframe.nativeElement;
    iframeEl.addEventListener('load', () => {

      if (!iframeEl.contentDocument) {
        return;
      }

      // 向外传递click事件
      iframeEl.contentDocument.addEventListener('click', (e) => {
        this.el.nativeElement.click();
        this.iframeClick.emit(e);
      });

      // 向外传递按键事件，实现全局支持快捷键操作
      iframeEl.contentDocument.addEventListener('keydown', (e) => {
        this.controller.keydownEmitter.next(e);
      });

      // 向外传递mouseup事件，防止滚动条粘到光标上
      iframeEl.contentDocument.addEventListener('mouseup', (e) => {
        if (!e.isTrusted) {
          return;
        }
        const el: HTMLIFrameElement = this.iframe.nativeElement;
        const boundingClientRect = el.getBoundingClientRect();
        const xOffset = boundingClientRect.left;
        const yOffset = boundingClientRect.top;
        try {
          const upEvt = new MouseEvent("mouseup", {
            "bubbles": true,
            "cancelable": false,
            "screenX": e.screenX,
            "screenY": e.screenY,
            "clientX": e.clientX + xOffset,
            "clientY": e.clientY + yOffset,
            "ctrlKey": e.ctrlKey,
            "shiftKey": e.shiftKey,
            "altKey": e.altKey,
            "metaKey": e.metaKey,
            "button": e.button,
            "buttons": e.buttons,
            "relatedTarget": e.relatedTarget
          });
          document.dispatchEvent(upEvt);
        } catch (err) { }
      });

      // 向外传递mousemove事件，让滚动条可以拖动
      iframeEl.contentDocument.addEventListener('mousemove', (e) => {
        if (!e.isTrusted) {
          return;
        }
        const el: HTMLIFrameElement = this.iframe.nativeElement;
        const boundingClientRect = el.getBoundingClientRect();
        const xOffset = boundingClientRect.left;
        const yOffset = boundingClientRect.top;
        try {
          const moveEvt = new MouseEvent("mousemove", {
            "bubbles": true,
            "cancelable": false,
            "screenX": e.screenX,
            "screenY": e.screenY,
            "clientX": e.clientX + xOffset,
            "clientY": e.clientY + yOffset,
            "ctrlKey": e.ctrlKey,
            "shiftKey": e.shiftKey,
            "altKey": e.altKey,
            "metaKey": e.metaKey,
            "button": e.button,
            "buttons": e.buttons,
            "relatedTarget": e.relatedTarget
          });
          document.dispatchEvent(moveEvt);
        } catch (err) { }
      });
    });
  }

  handleLoadEvent(): void {
    !!this.handleLoad && this.handleLoad(this.iframe.nativeElement);
  }

  ngOnDestroy(): void {
    this.iframe.nativeElement.src = 'about:blank';
    this.iframe.nativeElement.contentWindow.document.write('');
    this.iframe.nativeElement.contentWindow.document.clear && this.iframe.nativeElement.contentWindow.document.clear();
    this.iframe.nativeElement.parentNode.removeChild(this.iframe.nativeElement);
    this.iframe = null;
  }

}

@NgModule({
  imports: [],
  exports: [PanelFrameComponent, SafeUrlPipe],
  declarations: [PanelFrameComponent, SafeUrlPipe]
})
export class PanelFrameModule { }
